// External libraries
import gql from 'graphql-tag';

// Keeping the name as getPasskeyEnrollmentContext as the elmo
// call in this query is only for the ramp period
export const GET_PASSKEY_ENROLLMENT_CONTEXT_QUERY = gql`
  query getPasskeyEnrollmentContext(
    $browserName: String!
    $channel: String!
    $countryCodeAsString: String!
    $integrationType: String!
    $os: String!
    $token: String!
  ) {
    passkeyEnrollmentContext(token: $token, integrationType: $integrationType) {
      context
    }
    elmoExperiment(
      app: "checkoutuinodeweb"
      filters: [
        { key: "browserName", value: $browserName }
        { key: "Country", value: $countryCodeAsString }
        { key: "Channel", value: $channel }
        { key: "os", value: $os }
      ]
      res: "weasley:featureFlags::passkey"
    ) {
      __typename
      treatments {
        __typename
        experimentId
        experimentName
        factors {
          __typename
          key
          value
        }
        treatmentId
        treatmentName
      }
    }
  }
`;
